import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-general-confirm-modal',
  templateUrl: './general-confirm-modal.component.html',
  styleUrls: ['./general-confirm-modal.component.scss']
})
export class GeneralConfirmModalComponent implements OnInit {

  

  ngOnInit() {
  }

  constructor(
    public dialogRef: MatDialogRef<GeneralConfirmModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { header : string, text : string, modalParam:any}) {}

  onNoClick(): void {
    this.dialogRef.close();
  }

}
